import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import { loadCalendlyScript } from "@/lib/calendly";

import Home from "@/pages/Home";
import ProjectDetail from "@/pages/ProjectDetail";
import ArticleReader from "@/pages/ArticleReader";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import FloatingConnectButton from "@/components/connect/FloatingConnectButton";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSections from "@/pages/admin/AdminSections";
import AdminSectionEditor from "@/pages/admin/AdminSectionEditor";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminCareer from "@/pages/admin/AdminCareer";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminServices from "@/pages/admin/AdminServices";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminThoughts from "@/pages/admin/AdminThoughts";
import AdminImpact from "@/pages/admin/AdminImpact";
import AdminImpactCategories from "@/pages/admin/AdminImpactCategories";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminNavigation from "@/pages/admin/AdminNavigation";
import AdminAppearance from "@/pages/admin/AdminAppearance";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminUsers from "@/pages/admin/AdminUsers";
import ThemeInjector from "@/components/site/ThemeInjector";
import AnalyticsProvider from "@/components/site/AnalyticsProvider";

function App() {
  // Preload the Calendly widget script/stylesheet once at the app root so
  // every "Let's Talk" / "Schedule" CTA can open the popup scheduler instantly.
  useEffect(() => {
    loadCalendlyScript();
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <ThemeInjector />
        <AnalyticsProvider />
        <Toaster position="top-center" richColors />
        <FloatingConnectButton />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/thoughts/:slug" element={<ArticleReader />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="sections" element={<AdminSections />} />
            <Route path="sections/:id" element={<AdminSectionEditor />} />
            <Route path="media" element={<AdminMedia />} />
            <Route path="career" element={<AdminCareer />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="thoughts" element={<AdminThoughts />} />
            <Route path="impact" element={<AdminImpact />} />
            <Route path="impact-categories" element={<AdminImpactCategories />} />
            <Route path="inquiries" element={<AdminInquiries />} />
            <Route path="newsletter" element={<AdminNewsletter />} />
            <Route path="navigation" element={<AdminNavigation />} />
            <Route path="appearance" element={<AdminAppearance />} />
            <Route path="analytics" element={<AdminAnalytics />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
